module.exports = __webpack_public_path__ + "img/icon-truck.7a700279.svg";